import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor() { }

  public get copyright(): CopyrightInfo {

    return {
      year: '2022',
      organization: 'Ninh Nhi'
    };
  }

  public get app(): AppInfo {

    return {
      name: 'Ninh Nhi Management Portal',
      description: 'Cổng quản lý công ty Ninh Nhi.',
      version: '1.0.0',
      author: 'Rova'
    };
  }
}

export interface CopyrightInfo {
  organization: string;
  year: string;
}

export interface AppInfo {
  name: string;
  description: string;
  version: string;
  author: string;
}
